import script from "./InitializeFormMixin.vue?vue&type=script&lang=js"
export * from "./InitializeFormMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__